export class SubmitMyMPARequestResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequest",
            "baseName": "mpaRequest",
            "type": "MPARequest",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubmitMyMPARequestResponse.attributeTypeMap;
    }
    constructor() {
    }
}
